module.exports = __webpack_public_path__ + "img/kangxin2.4e0c36fc.png";